module.exports = __webpack_public_path__ + "static/media/settings-search-icon1.d447c9ce.svg";